import { INotification } from '../../../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { NotificationType } from '../../../../../../../models/notification.models';

export const getIncorrectPurchasesNotifications = (
  notifications: INotification[],
): INotification[] => notifications
  .filter(({ notificationType }) => notificationType === NotificationType.INCORRECT_PURCHASES
    || notificationType === NotificationType.USER_BLOCKED);